import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import InViewObserver from 'components/InViewObserver';
import makeRequest from 'utils/makeRequest';
// import { getFbnFanAdCode } from 'helpers/ads/utils';
// import { gaWrapper } from 'helpers/analytics';
// import Socials from '../../../components_v2/desktop/Header/Socials/WithSocials';
// import ElementInView from '../../../components_v2/common/ElementInView';
import { getSectionName } from '../../../utils/common';
import LoadableComponentLoader from '../../common/LoadableComponentLoader/LoadableComponentLoader';
import s from './Footer.scss';
import analyticsWrapper from '../../../helpers/analytics/analyticsWrapper';

// eslint-disable-next-line react/prop-types
const RenderSection = ({ secData, isPrivateUser, fullWidth = false }) => {
  const gaAction = 'Footer_Actions';
  const label =
    typeof secData.label === 'string'
      ? `Under${secData.label.split(' ').join('')}-`
      : 'UnderTOI-';
  if (secData && secData.items instanceof Array && secData.items.length > 0) {
    return (
      <div className={s.section} key={secData.label}>
        {secData.label ? (
          <h7 className={`${s.section_heading}`}>{secData.label}</h7>
        ) : null}
        <div
          className={`${s.section_items} ${fullWidth ? s.section_f_width : ''}`}
        >
          {secData.items.map(col => (
            <Link
              to={col.eulink && isPrivateUser ? col.eulink : col.wu}
              key={col.wu}
              className={col.cls}
              data={{
                gaAction,
                gaLabel: `${label}${col.hl}`,
              }}
            >
              {col.hl}
            </Link>
          ))}
        </div>
      </div>
    );
  }
  return null;
};

class Footer extends React.Component {
  constructor() {
    super();
    this.state = { footerIconVisible: false };
    this.triggerGa = true;
  }

  componentDidMount() {
    if (
      typeof window !== 'undefined' &&
      window.geoinfo &&
      (typeof window.geoinfo.CountryCode === 'string' ||
        typeof window.geoinfo.region_code === 'string')
    ) {
      if (
        window.geoinfo.CountryCode === 'US' &&
        window.geoinfo.region_code === 'CA'
      ) {
        this.addAdditionalLinks();
      }
    }

    const { footerData } = this.props;
    if (
      footerData &&
      footerData.lastSectionItems &&
      Array.isArray(footerData.lastSectionItems.items)
    ) {
      this.initIntervalUpdation();
    }
  }

  initIntervalUpdation = () => {
    setInterval(() => {
      const url =
        'https://plus.timesofindia.com/toi-feed/top-news/fetch/latest/articles/toi';
      makeRequest.get(url, {}).then(response => {
        if (response && Array.isArray(response.data)) {
          this.setState({
            lastSectionItems: {
              label: 'Latest News',
              items: response.data.slice(0, 18),
            },
          });
        }
      });
    }, 600000);
  };

  addAdditionalLinks = () => {
    if (
      this.props.footerData?.siteLinks?.items &&
      Array.isArray(this.props.footerData.siteLinks.items)
    )
      this.props.footerData.siteLinks.items.push(
        {
          wu: 'https://timesofindia.indiatimes.com/donotsell.cms',
          hl: 'Do Not Sell Data',
        },
        {
          wu: 'https://timesofindia.indiatimes.com/cookie-policy',
          hl: 'Cookie Policy',
        },
      );
  };

  getRefreshTime() {
    const { adRefreshRate } = this.props;
    return adRefreshRate && adRefreshRate > 0
      ? adRefreshRate
      : this.defaultAdRefreshInterval;
  }

  render() {
    const {
      footerData = {},
      frmapp,
      footerWithOnlyFbn,
      hideFbn,
      hideAds,
      hideFooterAdMargin,
    } = this.props;
    const { footerIconVisible } = this.state;
    if (footerData) {
      if (!hideAds && !hideFbn && (frmapp || footerWithOnlyFbn)) {
        return null;
      }
      if (hideAds && !hideFbn && frmapp) {
        return null;
      }
      const isMobile = true;
      const sectionName = getSectionName(
        this.props.articleSectionData,
        this.props.newsData,
        this.props.msid,
        this.props.liveblogData,
        this.props.breadCrumb,
        isMobile,
      );

      return (
        <footer
          className={`${s.footer_container} ${hideFooterAdMargin &&
            s.hidemargin}`}
          data-translate-id="cw"
          data-bottom-space={130}
        >
          <div
            className={`${this.props.useContentVisibilty &&
              s.footer_intrinsic_size}`}
          >
            {/* <ElementInView
              gaCategory="mweb_bottom_footer_toi"
              gaAction="social_profile_icons"
              gaLabel="view"
            > */}
            <LoadableComponentLoader
              loadOnScroll
              loadableComponentName="WithSocials"
              colorTheme="snowwhite"
              showTitle
              showKoo
              showWiki
              showGnews
              isFooter
              isMweb
              sectionName={sectionName}
            />
            {/* </ElementInView> */}
            <div className={`${s.footer_sitelinks} `}>
              <InViewObserver
                inViewCallback={() => {
                  this.setState({
                    footerIconVisible: true,
                  });
                  analyticsWrapper('ga4', {
                    event: 'user_shown',
                    type: 'social_icons',
                    category: 'footer',
                  });
                }}
                viewMargin="50px 0px 50px 0px"
              >
                {footerData.logo ? (
                  <Link
                    className={`${s.logo} ${
                      footerIconVisible ? s.logo_background : ''
                    }`}
                    to={footerData.logo.link}
                    title="TOI"
                  />
                ) : null}
              </InViewObserver>
              {footerData.siteLinks && (
                <RenderSection
                  secData={footerData.siteLinks}
                  isPrivateUser={this.props.isPrivateUser}
                />
              )}
            </div>

            {footerData.sections instanceof Array &&
              footerData.sections.map(item => (
                <RenderSection
                  secData={item}
                  isPrivateUser={this.props.isPrivateUser}
                />
              ))}
            {((footerData.lastSectionItems &&
              Array.isArray(footerData.lastSectionItems.items)) ||
              (this.state.lastSectionItems &&
                Array.isArray(this.state.lastSectionItems.items))) && (
              <RenderSection
                secData={
                  this.state.lastSectionItems || footerData.lastSectionItems
                }
                isPrivateUser={this.props.isPrivateUser}
                fullWidth
              />
            )}
            {footerData.disclaimer ? (
              <div className={s.disclaimer}>{footerData.disclaimer}</div>
            ) : null}
          </div>
        </footer>
      );
    }

    return null;
  }
}

Footer.propTypes = {
  footerData: PropTypes.shape({}).isRequired,
  fbnAdCodeObject: PropTypes.shape({}),
  frmapp: PropTypes.bool,
  footerWithOnlyFbn: PropTypes.bool,
  params: PropTypes.shape({
    fullPath: PropTypes.string,
  }).isRequired,
  refreshFbnAdsData: PropTypes.shape({}),
  appAdCode: PropTypes.shape({}),
  fbnAdsData: PropTypes.shape({}),
  adRefreshRate: PropTypes.number,
  hideFbn: PropTypes.bool,
  hideAds: PropTypes.bool,
  isPrivateUser: PropTypes.bool.isRequired,
  useContentVisibilty: PropTypes.bool,
  nativeCampaignData: PropTypes.shape({}).isRequired,
  hideFooterAdMargin: PropTypes.bool,
};
Footer.defaultProps = {
  fbnAdCodeObject: undefined,
  frmapp: false,
  footerWithOnlyFbn: false,
  refreshFbnAdsData: undefined,
  appAdCode: undefined,
  fbnAdsData: undefined,
  adRefreshRate: 0,
  hideFbn: false,
  hideAds: false,
  useContentVisibilty: false,
  hideFooterAdMargin: false,
};

export default Footer;
